module.exports = __webpack_public_path__ + "static/media/giovanni-miss.64e5960e.wav";